import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapDCompanyToApiDCompanyDto = (values: ICreateDCompanyForm): IPostNewDCompany | {} => {
  let dataMapping: IPostNewDCompany ;

  dataMapping = {
    description: values.description,
    placeID: +values.placeID !== 0 ? +values.placeID : null,
    modemID: +values.modemID !== 0 ? +values.modemID : null,
    modemPort: values.modemPort !== "" ? values.modemPort : null,
    unID: values.unID,
    sapCode: values.sapCode !== "" ? values.sapCode : null,
    isEmporiki: values.isEmporiki,
    isCiti: values.isCiti
  }

  return dataMapping;
}


export const createDCompany = ( {data} : {data: ICreateDCompanyForm }): Promise<string> => {
  const dCompany = mapDCompanyToApiDCompanyDto(data);
  return axiosDefaultApi.post(`/api/DCompanies/InsertDCompany`, dCompany);
};

type QueryFnType = typeof createDCompany;

type UseCreateDCompanyOptions = {
  data: IPostNewDCompany | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateDCompany = ({ config }: UseCreateDCompanyOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία της Θυγατρικής.`, 500);
            console.error('Couldnt create new DCompany', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllDCompanies"])
            addNotification(`Η Θυγατρική Δημιουργήθηκε.`, 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createDCompany,
    })
}